import { createSelector } from 'reselect'
import _get from 'lodash/get'
import _cloneDeep from 'lodash/cloneDeep'

export const get_users = createSelector(state => _get(state, 'users.usersData.data'), _cloneDeep)

export default get_users
